import React, { useState, useEffect, useRef, use } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import BuildCoin from './images/buildcoin.png';
import Share from './images/Share.png';
 import ListView from './images/ListView.png';
 import Coininhand from './images/Coininhand.png';
 import File from './images/File.png';
import Map from './images/Map.png';
import ArrowLeft from './images/ArrowLeft.png';
import Building from './images/Building1.png';
import BucketEmptyConfirmPopup from './Component/BucketEmptyConfirmPopup';
import warningimg from './images/warningimg.png';
import ChangeLocationPopup from './Component/ChangeLocationPopup';
import { motion , AnimatePresence} from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';
import HeaderBar from './Component/Header2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faExclamationTriangle, faPen,faTruckFast, faClock, faCalendarCheck, faInfoCircle,faTruck ,faTrash, faXmark, faImage  } from '@fortawesome/free-solid-svg-icons';
import Bucket from "./images/Gray_Bucket.png";
import ProductSearchOverlay from './Component/ProductSearchoverlay';
import useOutsideClick from "./Component/OutsideClick"; 
import defaultimg from "./images/defaultimg.png";
 

 
const CartPreview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, project } = location.state || {};
  console.log('Project ID:', projectId);
  console.log('Project:', project);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const showPopupRef = useRef(null);

   const qtyInputRef = useRef(null);
const isQtyFocused = useRef(false);
const lastValidQtyRef = useRef(1);
const currentQtyRef = useRef("");
const focusedItemIdRef = useRef(null);

  useOutsideClick(showPopupRef, () => setShowPopup(false));
  
 
  const [cartItems, setCartItems] = useState([]);
  //console.log('Cart Items:', cartItems);
  const { fromNewRFQ, rfqItems, rfqCategoryId, rfqCategoryName } = location.state || {};


 const [appliedCoins, setAppliedCoins] = useState(() => {
  const navCoins = location?.state?.appliedCoins;
  const storedCoins = parseInt(localStorage.getItem('buildcoins_applied_amount') || "0");
  return navCoins || storedCoins || 0;
});
const [showDeleteBottomSheet, setShowDeleteBottomSheet] = useState(false);

const [discount, setDiscount] = useState(appliedCoins);
const [ledgerId, setLedgerId] = useState(location?.state?.ledgerId || null);
   const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const [walletCoinsApplicable,setWalletCoinsApplicable] = useState(0)
  const [walletCoinsApplied, setWalletCoinsApplied] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [coinLedger,setCoinLedger] = useState({});
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const [showSharePopup, setShowSharePopup] = useState(false);

const [showLocationPopup, setShowLocationPopup] = useState(false);
const [savedAddresses, setSavedAddresses] = useState([]);

  const [buildcoinsApplied, setBuildcoinsApplied] = useState(false);
const buildcoinsDiscount = buildcoinsApplied ? 200 : 0;
const [projects, setProjects] = useState([]);
const [selectedProject, setSelectedProject] = useState(null);
const [deliveryAddresses, setDeliveryAddresses] = useState([]);
const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
const [showEmptyBucketPopup, setShowEmptyBucketPopup] = useState(false);
const [pendingRemoveItem, setPendingRemoveItem] = useState(null);
const [showAddressRequiredPopup, setShowAddressRequiredPopup] = useState(false);
const [showAddressOptionsPopup, setShowAddressOptionsPopup] = useState(false);
const [selectedAddressForOptions, setSelectedAddressForOptions] = useState(null);
const [showOrderPlacedPopup, setShowOrderPlacedPopup] = useState(false);
const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
const [categories, setCategories] = useState([]);
// Get quotationId from location.state or URLSearchParams
const stateQuotationId = location?.state?.quotationId;
const params = new URLSearchParams(location?.search);
//console.log("params:",params)
const paramQuotationId = params.get('quotationId');
const rawData = params.get('data');

// Final quotationId (from state, then param, or null)
const quotationId = stateQuotationId || paramQuotationId || null;
//console.log('quotationId:', quotationId);

const [quotationData, setQuotationData] = useState(null);
const [isExistingQuotation, setIsExistingQuotation] = useState(false);

const buildcoinDiscount = location.state?.appliedCoins || 0;
const totalDiscount = discount + buildcoinDiscount;
const [appliedLedgerId, setAppliedLedgerId] = useState(() => localStorage.getItem('buildcoins_applied_ledger'));
const [catgoriesNames,setCategoriesNames] = useState([]);
const [brands, setBrands] = useState([]);
const [loading , setLoading] = useState(true);

const [rewardableCoins, setRewardableCoins] = useState(0);
const [redeemableCoins, setRedeemableCoins] = useState(0);
const [redeemableItems,setRedeemableItems] = useState([]);
console.log("redeemableItems:",redeemableItems)
const [checked, setChecked] = useState(false);
const [showPopup, setShowPopup] = useState(false);
const [isProductSearchOpen, setIsProductSearchOpen] = useState(false);
const [allUOMs, setAllUOMs] = useState([]);
  

useEffect(() => {
  if (rawData) {
    try {
      const data = JSON.parse(decodeURIComponent(rawData));  // decode and parse

      // Store in local/session storage
      localStorage.setItem('userData', JSON.stringify(data));
      sessionStorage.setItem('userData', JSON.stringify(data));
      sessionStorage.setItem('customerId', data._id);
      sessionStorage.setItem('token', data.token);
      sessionStorage.setItem('hubId', data.hubId);
      sessionStorage.setItem('roleId', data.roleId);
      localStorage.setItem('userId', data._id);
    } catch (err) {
      console.error('Invalid data param:', err);
    }
  }
}, [rawData]);

useEffect(() => {
  fetchAllUOMs();
}, []);


useEffect(() => {
  if (appliedCoins > 0) {
    setDiscount(appliedCoins);
  } else {
    setDiscount(0);
  }
}, [appliedCoins]);

useEffect(() => {
  const alreadyCleared = sessionStorage.getItem('buildcoins_reset');
  
  if ((!quotationData || !quotationData._id) && !alreadyCleared) {
    localStorage.removeItem('buildcoins_applied_ledger');
    localStorage.removeItem('buildcoins_applied_amount');

    // ✅ Mark as cleared so this doesn't re-run
    sessionStorage.setItem('buildcoins_reset', 'true');
  }
}, [quotationData]);


useEffect(() => {
  // Handle quotation ID from navigation state
  const quotationIdFromState = location.state?.quotationId;
  
  if (quotationIdFromState) {
    console.log('📋 Quotation ID found:', quotationIdFromState);
    fetchQuotationDetails(quotationIdFromState);
  }
}, [location.state?.quotationId]);


useEffect(() => {
  if (paramQuotationId) {
    console.log('📋 Quotation ID found:', paramQuotationId);
    fetchQuotationDetails(paramQuotationId);
  }
},[paramQuotationId]);


// Initialize selectedProject with first project when projects load
useEffect(() => {
  // Handle both new address and updated address from AddAddress
  if (location.state?.showLocationPopup && (location.state?.newAddressAdded || location.state?.addressUpdated)) {
   
    fetchDeliveryAddresses().then(() => {
      setShowLocationPopup(true);
    });
  } else if (location.state?.addressUpdated) {
    fetchDeliveryAddresses();
  }
  if (location.state?.showLocationPopup || location.state?.addressUpdated || location.state?.newAddressAdded) {
    window.history.replaceState({}, document.title);
  }
}, [location.state]);


useEffect(() => {
  if (!window.visualViewport) return;

  let lastHeight = window.visualViewport.height;

  const handleResize = () => {
    const newHeight = window.visualViewport.height;

    // 👉 KEYBOARD CLOSED (height increases)
    if (newHeight > lastHeight + 50 && isQtyFocused.current) {

      const cur = currentQtyRef.current;

      // If user cleared → restore previous qty
      if (cur === "" || cur === "0") {
        handleMainProductQuantityInputChange(
          focusedItemIdRef.current,
          String(lastValidQtyRef.current)
        );
      }

      // 🔥 This removes cursor 100% on Android + iOS
      if (qtyInputRef.current) qtyInputRef.current.blur();
      if (document.activeElement) document.activeElement.blur();

      isQtyFocused.current = false;
    }

    lastHeight = newHeight;
  };

  window.visualViewport.addEventListener("resize", handleResize);
  return () => window.visualViewport.removeEventListener("resize", handleResize);
}, []);


useEffect(() => {
  const loadBucketProducts = () => {
    const savedBucketItems = localStorage.getItem("bucketProducts");
    if (savedBucketItems) {
      const bucketItems = JSON.parse(savedBucketItems);
      const mappedCartItems = Object.values(bucketItems).map(item => ({ ...item }));
      setCartItems(mappedCartItems);
      console.log("Loaded bucket items:", mappedCartItems);
    } else {
      setCartItems([]);
    }
  };

 
  const reloadData = async () => {
    await fetchCategories(); 
    loadBucketProducts(); 
    
  };

  reloadData();

  
  const handleFocus = () => reloadData();
  window.addEventListener("focus", handleFocus);

  if (!isProductSearchOpen) {
    reloadData();
  }

  return () => window.removeEventListener("focus", handleFocus);
}, [isProductSearchOpen, location.key]);


  useEffect(() => {
  const isApplied = localStorage.getItem('buildcoins_applied') === 'true';
  setBuildcoinsApplied(isApplied);
}, []);

// cartItems → items in cart 
// redeemableItems → data you shared

const calculateTotals = (cartItems, redeemableItems) => {

  let subtotal = 0;
  let taxAmount = 0;

  cartItems.forEach(cartItem => {

    // find the redeemable item by ID
    const redeemItem = redeemableItems?.find(r => r.item_id === cartItem._id);

    // If redeem data not found → no coins
    const coins = redeemItem ? redeemItem.coins : 0;

    // reduce selling price by coins
    //const effectivePrice = Math.max(cartItem.selling_price - coins, 0);

    // GST % (ex: 18)
    const gstRate = cartItem.GST || cartItem.IGST || 0;
    const eachSubtotal = cartItem.selling_price * cartItem.quantity;
    const effectivePrice = eachSubtotal - coins;
    // Subtotal calculation (normal selling price × qty)
    subtotal += cartItem.selling_price * cartItem.quantity;

    // Correct tax calculation
    taxAmount += (effectivePrice * (gstRate / 100));
  });

  // Round the tax
  taxAmount = Math.round(taxAmount);

  return { subtotal, taxAmount };
};

console.log("cartItems for totals calculation:",cartItems)

const { subtotal, taxAmount } = calculateTotals(cartItems, redeemableItems);
  // Calculate total
  const cartTotal = subtotal //cartItems.reduce((total, item) => total + (item.selling_price * item.quantity), 0);
  const TaxAmount = taxAmount

  console.log("Subtotal:",subtotal, "TaxAmount:",taxAmount,);
// New useEffect to call getApplicableBuildcoins when cartTotal changes


const getApplicableBuildcoins = async (updatedItems) => {
/*   const token = sessionStorage.getItem('token');
  const customer = JSON.parse(localStorage.getItem('userData'));
  console.log(customer)
  const customerId = customer._id
  console.log(customerId)
  console.log(cartTotal)
  const consumer_id =  sessionStorage.getItem('consumer_id') || customerId;
  const category = categories;
  console.log(category)
  const brand = brands;
  console.log(brand)
  const partner_id = '6889abb0dc50d682fe38fae2';
  const is_ecommerce = true; */
  const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    const processedItems = updatedItems.map(item => ({
      _id: item._id,
      name: item.product_name,
      price: item.selling_price || 0,
      quantity: item.quantity,
    }));

    console.log("processedItems:",processedItems)

    const processedCategories = [...new Set(updatedItems.map(item => {
      const foundCategory = categories.find(cat => cat._id === item.product_category_id);
      return foundCategory ? foundCategory.product_category_name : 'Other Products';
    }))];

    const processedBrands =  [...new Set(updatedItems.map(item => {
      const foundBrand = brands.find(brand => brand._id === item.vendor_id);
      return foundBrand ? foundBrand.name : 'Other Products';
    }))];


    const totalAmount =  Math.round(processedItems.reduce((total, item) => total + (item.price * item.quantity) + (item.price * 0.18 * item.quantity), 0));
    console.log('Total amount for rewards:', totalAmount);

  const context = {
    consumer_id: customerId,
    items: processedItems,
    totalAmount: totalAmount,
    brand: processedBrands,
    category: processedCategories,
    partner_id: '6889abb0dc50d682fe38fae2',
  };
  console.log('Reward calculation context:', context);
  try {
    //const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/get-applicable-buildcoins-from-wallet?consumer_id=${consumer_id}&category=${category}&brand=${brand}&is_ecommerce=${is_ecommerce}&amount=${cartTotal}&partner_id=${partner_id}`, {
      //method: 'GET',
   const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/calculate-redeem-coins`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(context)
    });
           
    const data = await response.json();
    console.log("fetched applicable coins:",data)
    //setWalletCoinsApplicable(data?.applicable_coins)
    //setCoinLedger(data[0]);
    //setCoinLedgers(data ? data.applicable_coins : []);
    //setRedeemableCoins(data?.total_usable_coins);
      setRedeemableCoins(data?.data.rewards[0]?.coins || 0);
      setRedeemableItems(data?.data.items_coins)

  } catch (err) {
    console.error('Error getting buildcoins wallet:', err);
  }
}; 


useEffect(() => {
  fetchCategories();
  fetchBrands();
}, []);


  const [confirmationStatus, setConfirmationStatus] = useState('initial');
   const [priceApproved, setPriceApproved] = useState(true);
 

useEffect(() => {
  if (deliveryAddresses && deliveryAddresses.length > 0 && !selectedDeliveryAddress) {
    // First fetch the last used address, then set it
    //fetchConsumerLastUsedDeliveryAddress();
    const customerId = deliveryAddresses[0].customer_id
    getDefaultDeliveryAddress(customerId)
  }
}, [deliveryAddresses]);

const getDefaultDeliveryAddress = async (customer_id) => {
  try {
    if (!customer_id) throw new Error('Customer ID is required');

    const url = process.env.REACT_APP_FORE_BRICKBUCKET;
    const token = sessionStorage.getItem('token');

    const response = await fetch(
      `${url}customer/delivery-address/getDefaultDeliveryAddress?customer_id=${customer_id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
     setSelectedDeliveryAddress(data.data)
    } else {
      console.error('Failed to fetch default delivery address:', data.message);
      return null;
    }
  } catch (error) {
    console.error('Error fetching default delivery address:', error);
    return null;
  }
};

  // Handle clicks outside the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    // Add event listener when menu is open
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);


 useEffect(() => {
  const initializeAddresses = async () => {
    await fetchProjectsByCustomerId();
    await fetchDeliveryAddresses(); 
    
    if (location.state?.newAddressAdded) {
      setTimeout(() => {
        fetchDeliveryAddresses();
      }, 500);
    }
  };
  
  initializeAddresses();
}, [location.state?.newAddressAdded]);


useEffect(() => {
  if (quotationData?.product_categories) {
    // Extract all category names
    const categories = quotationData.product_categories.map(cat => cat.product_category_name);

    // Extract all manufacturer names (brands) from all items in all categories
    const brands = quotationData.product_categories
      .flatMap(cat => cat.items?.map(item => item.manufacturer_name).filter(Boolean))
      .filter((value, index, self) => self.indexOf(value) === index);

    // You can set these to state if you want to use them elsewhere
     setCategoriesNames(categories);
     setBrands(brands);
  }
}, [quotationData]);


useEffect(() => {
  if (cartItems.length > 0 && categories.length > 0 && brands.length > 0) {
    //console.log("cartItems:",cartItems)
    fetchRewards(cartItems);
    getApplicableBuildcoins(cartItems);
  }
}, [cartItems, categories, brands]);


const handleDeleteAddress = () => {
  if (!selectedAddressForOptions) return;
  
  // Show confirmation popup instead of directly deleting
  setShowDeleteConfirmPopup(true);
};
const fetchAllUOMs = async () => {
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${fetchUrl}UOMs/get-all-UOMs`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      setAllUOMs(data.data);
    }
    console.log(data);
  };


const fetchQuotationDetails = async (quotationId) => {
  try {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    console.log('🔍 Fetching quotation with token:', token); 
    
    const response = await fetch(`${fetchUrl}customer/quotations/get-quotation-by-its-id?quotation_id=${quotationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });

    const data = await response.json();
  //  console.log('📦 Quotation Data Response:', data);
    
    if (data.success) {
      setQuotationData(data.data);
    //  console.log('✅ Quotation Data Set:', data.data);
    } else {
      console.error('❌ Failed to fetch quotation:', data.message);
    }
  } catch (error) {
    console.error('💥 Error fetching quotation:', error);
  }
  finally {
    setLoading(false);
  }
};

// Add the actual delete function that executes after confirmation
const confirmDeleteAddress = async () => {
  if (!selectedAddressForOptions) return;
  
  try {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const token = userData?.token;

    if (!token) {
      console.error('Authentication token not found');
      return;
    }

    // Send address_id as query parameter to match backend req.query
    const response = await fetch(`${fetchUrl}customer/delivery-address/deleteDeliveryAddress?address_id=${selectedAddressForOptions._id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    //console.log('Delete response:', data);
    
    if (data.success) {
      // Refresh delivery addresses
      await fetchDeliveryAddresses();
      setShowAddressOptionsPopup(false);
      setSelectedAddressForOptions(null);
      setShowDeleteConfirmPopup(false); // Close confirmation popup
      
      // If deleted address was selected, clear selection
      if (selectedDeliveryAddress?._id === selectedAddressForOptions._id) {
        setSelectedDeliveryAddress(null);
      }
      
      //console.log('Address deleted successfully');
    } else {
      console.error('Failed to delete address:', data.message);
      setShowDeleteConfirmPopup(false); // Close popup on error
    }
  } catch (error) {
    console.error('Error deleting address:', error);
    setShowDeleteConfirmPopup(false); // Close popup on error
  }
};


// ✅ FIXED version
const groupItemsByCategory = (items, categories = []) => {
  return items.reduce((groups, item) => {
    // guard clause
    if (!item || !item.product_category_id) {
      const fallback = "Other Products";
      if (!groups[fallback]) groups[fallback] = [];
      groups[fallback].push(item);
      return groups;
    }

    // safe extraction
    const itemCategoryId =
      typeof item.product_category_id === "object"
        ? item.product_category_id._id
        : item.product_category_id;

    const foundCategory = categories.find(
      (cat) => cat._id?.toString() === itemCategoryId?.toString()
    );

    const categoryName =
      foundCategory?.product_category_name ||
      item.product_category_name ||
      item.product_category_id?.product_category_name ||
      "Other Products";

    if (!groups[categoryName]) groups[categoryName] = [];
    groups[categoryName].push(item);

    return groups;
  }, {});
};



const handleEditAddress = () => {
  setShowAddressOptionsPopup(false);
  setShowLocationPopup(false);
  navigate('/consumer/addaddress', { 
    state: { 
      editMode: true,
      addressData: selectedAddressForOptions,
      fromCartPreview: true
    } 
  });
};



const fetchConsumerLastUsedDeliveryAddress = async () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    if (!customerId || !token) {
      console.error('Customer ID or token not found');
      return;
    }

    const response = await fetch(`${fetchUrl}customer/delivery-address/get-consumer-last-used-delivery-address?customer_id=${customerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      }
    });

    const data = await response.json();
    console.log('Last used address response:', data);
    
    if (data.success && data.data) {
      const lastUsedAddressId = data.data;
      
      // Wait a bit for deliveryAddresses to be populated if needed
      setTimeout(() => {
        const lastUsedAddress = deliveryAddresses.find(address => address._id === lastUsedAddressId);
        
        if (lastUsedAddress) {
          setSelectedDeliveryAddress(lastUsedAddress);
        } else {
          if (deliveryAddresses.length > 0) {
            setSelectedDeliveryAddress(deliveryAddresses[0]);
          }
        }
      }, 100);
    } else {
      // If no last used address found, use the first available
      if (deliveryAddresses.length > 0) {
        setSelectedDeliveryAddress(deliveryAddresses[0]);
      }
    }
  } catch (error) {
    console.error('Error fetching last used delivery address:', error);
    // Fallback to first address
    if (deliveryAddresses.length > 0) {
      setSelectedDeliveryAddress(deliveryAddresses[0]);
    }
  }
};

const fetchCategories = async () => {
  try {
     const userData = JSON.parse(sessionStorage.getItem('userData'));
    const token = userData?.token;
    setLoading(true);
    const response = await fetch(fetchUrl + "product-category/get-all-productCategories?isEcommerce=true", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
        
      }
    });
    
    const data = await response.json();
    if (data.success) {
      setCategories(data.data);
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
  }
  finally {
    setLoading(false);
  }
};

const fetchBrands = async () => {
  try {
    const response = await fetch(fetchUrl + "vendor/get-all-brands", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': sessionStorage.getItem('token'),
      }
    });
    
    const data = await response.json();
    console.log('Brands response:', data);
    if (data.success) {
      setBrands(data.data);
    }
  } catch (error) {
    console.error('Error fetching brands:', error);
  }
};

const fetchRewards = async (updatedItems) => {
  console.log('Calculating rewards for items:', updatedItems);
  const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    const processedItems = updatedItems.map(item => ({
      _id: item._id,
      name: item.product_name,
      price: item.selling_price || 0,
      quantity: item.quantity,
    }));

    console.log("processedItems:",processedItems);

    const processedCategories = [...new Set(updatedItems.map(item => {
      const foundCategory = categories.find(cat => cat._id === item.product_category_id);
      return foundCategory ? foundCategory.product_category_name : 'Other Products';
    }))];

    const processedBrands =  [...new Set(updatedItems.map(item => {
      const foundBrand = brands.find(brand => brand._id === item.vendor_id);
      return foundBrand ? foundBrand.name : 'Other Products';
    }))];


    const totalAmount =  Math.round(processedItems.reduce((total, item) => total + (item.price * item.quantity) + (item.price * 0.18 * item.quantity), 0));
    console.log('Total amount for rewards:', totalAmount);

  const context = {
    consumer_id: customerId,
    items: processedItems,
    totalAmount: totalAmount,
    brand: processedBrands,
    category: processedCategories,
    items: processedItems,
    partner_id: '6889abb0dc50d682fe38fae2',
  };
  console.log('Reward calculation context:', context);
try{
   const endpoint = `${fetchUrl}rewards/calculate-reward-coins`;
    const method = 'POST';

    // Send to backend
    const response = await fetch(endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(context)
    });

    const data = await response.json();
    console.log('📊 Backend response for coins:', data);
      setRewardableCoins(data.data.total_coins);
      return { 
        success: true
      };
  } catch (error) {
    console.error('Error calculating reward coins:', error);
    return { success: false, message: 'An error occurred while calculating the rewards' };
  }
};

const fetchDeliveryAddresses = async () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    if (!customerId || !token) {
      console.error('Customer ID or token not found');
      return;
    }

    const response = await fetch(`${fetchUrl}customer/delivery-address/getDeliveryAddresses?customer_id=${customerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      }
    });

    const data = await response.json();
    console.log('Delivery addresses response:', data);
    
    if (data.success) {
      setDeliveryAddresses(data.data || []);
    } else {
      console.error('Failed to fetch delivery addresses:', data.message);
    }
  } catch (error) {
    console.error('Error fetching delivery addresses:', error);
  }
};


 const handleQuantityChange = (id, action) => {
  const currentItem = cartItems.find(item => item._id === id);

  if (!currentItem) return;

  // Handle decrease when quantity is 1
  if (action === 'decrease') {
    if (currentItem.quantity === 1) {

        if (cartItems.length === 1) {
            // Last item in cart — keep your existing popup
            setPendingRemoveItem(currentItem);
            setShowEmptyBucketPopup(true);
        } else {
            // NOT LAST ITEM → show new bottom sheet popup (DO NOT REMOVE DIRECTLY)
            setPendingRemoveItem(currentItem);
            setShowDeleteBottomSheet(true);
        }

        return;
    }
}


  // Normal increase/decrease logic
  setCartItems(prevItems => {
    const updatedItems = prevItems.map(item => {
      if (item._id === id) {
        const newQuantity =
          action === 'increase'
            ? item.quantity + 1
            : Math.max(1, item.quantity - 1);

             let savedItems = JSON.parse(sessionStorage.getItem("savedItems")) || [];
        savedItems = savedItems.map(si =>
          si.id === id ? { ...si, quantity: newQuantity } : si
        );
        sessionStorage.setItem("savedItems", JSON.stringify(savedItems));

        return { ...item, quantity: newQuantity };
      }
      return item;
    });

    // Update cartItems in localStorage
    //localStorage.setItem('cartItems', JSON.stringify(updatedItems));

    // Update bucketProducts in localStorage
    const savedBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');

    updatedItems.forEach(item => {
      savedBucketProducts[item._id] = {
       ...item
      };
    });

    // Remove any items that were deleted
    Object.keys(savedBucketProducts).forEach(pid => {
      if (!updatedItems.find(item => item._id === pid)) {
        delete savedBucketProducts[pid];
      }
    });

    localStorage.setItem('bucketProducts', JSON.stringify(savedBucketProducts));


    console.log("-----updated items before buildcoins calculations:------",updatedItems)

    // Optionally update rewards
    const rewardCoins = fetchRewards(updatedItems);
    const redeemableCoins = getApplicableBuildcoins(updatedItems);
    console.log('Rewards fetched:', rewardCoins);
    console.log('Redeemable coins:', redeemableCoins);

    return updatedItems;
  });
};

const handleMainProductQuantityInputChange = (id, value) => {
  // Parse value as number (handles string from input) and default to 1 if falsy, <=0, or <1
  const parsedValue = value === "" ? "" : parseInt(value, 10) || 0;
const effectiveValue =
    parsedValue === "" ? "" : parsedValue < 1 ? 1 : parsedValue;  setCartItems(prevItems => {
    const updatedItems = prevItems.map(item => {
      if (item._id === id) {
        return { ...item, quantity: effectiveValue };
      }
      return item;
    });

    const savedBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');

    updatedItems.forEach(item => {
      savedBucketProducts[item._id] = {
       ...item
      };
    });


    localStorage.setItem('bucketProducts', JSON.stringify(savedBucketProducts));

    return updatedItems;
  });
  
};


// Remove item and update bucketItems in localStorage
const performRemoveItem = (id) => {
  setCartItems(prevItems => {
    // Remove from cartItems
    const updatedItems = prevItems.filter(item => item._id !== id);

    // Update bucketItems in localStorage
    const savedBucketItems = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    if (savedBucketItems[id]) {
      delete savedBucketItems[id];
      localStorage.setItem('bucketProducts', JSON.stringify(savedBucketItems));
    }

    return updatedItems;
  });
};


const handleConfirm = async () => {
  if (pendingRemoveItem) {
   await  performRemoveItem(pendingRemoveItem._id);
    const remainingItems = cartItems.filter(item => item.id !== pendingRemoveItem.id);  
    if (remainingItems.length === 0) { 
      setTimeout(() => {
        navigate('/consumer/productCategories');
      }, ); 
    }
  }
  
  setShowEmptyBucketPopup(false);
  setPendingRemoveItem(null);
};


const handleShareClick = () => {
  setShowSharePopup(true);
};

const handleWhatsAppShare = () => {
  const cartItemsText = cartItems.map(item => 
    `${item.name} - Qty: ${item.quantity} - ₹${(item.selling_price * item.quantity).toLocaleString()}`
  ).join('\n');

  const totalAmount = cartItems.reduce((total, item) => total + (item.selling_price * item.quantity), 0);
  const message = `Check out my cart from BrickBucket:\n\n${cartItemsText}\n\nTotal: ₹${totalAmount.toLocaleString()}\n\nOrder now from BrickBucket app!`;
  
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');
  setShowSharePopup(false);
};

const handleOtherShare = (platform) => {
  const totalAmount = cartItems.reduce((total, item) => total + (item.selling_price * item.quantity), 0);
  const message = `Check out my cart from BrickBucket! Total: ₹${totalAmount.toLocaleString()}`;
  
  switch(platform) {
    case 'telegram':
      window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(message)}`, '_blank');
      break;
    case 'facebook':
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, '_blank');
      break;
    case 'twitter':
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(window.location.href)}`, '_blank');
      break;
    case 'copy':
      navigator.clipboard.writeText(`${message}\n${window.location.href}`);
      alert('Link copied to clipboard!');
      break;
  }
  setShowSharePopup(false);
};


const handleConfirmation = () => {

localStorage.removeItem('buildcoins_applied');
localStorage.removeItem('buildcoins_applied_ledger');
localStorage.removeItem('buildcoins_applied_amount');
sessionStorage.removeItem('buildcoins_reset');
  if (!selectedDeliveryAddress) {
    setShowAddressRequiredPopup(true);
    return;
  } 
  // Show order placed popup immediately when button is clicked
  setShowPopup(false);
  setShowOrderPlacedPopup(true);
  
  // Change status to requesting
  setConfirmationStatus('requesting');
  
  // Create and send quotation
  createAndSendQuotation()
    .then(result => {
      if (result.success) {
        setPriceApproved(true);
        // Keep popup showing for 2 more seconds after success
        setTimeout(() => {
          setShowOrderPlacedPopup(false);
        }, 3000);
        
      } else {
        setPriceApproved(false);
        // Hide popup on error
        setShowOrderPlacedPopup(false);
        alert(result.message || 'Failed to create quotation');
      }
    })
    .catch(error => {
      console.error('Error creating quotation:', error);
      setPriceApproved(false);
      // Hide popup on error
      setShowOrderPlacedPopup(false);
      alert('An error occurred while creating the quotation');
    });
};


// Helper function to create and send quotation
const createAndSendQuotation = async () => {
  try {
   
    const isUpdate = quotationData && quotationData._id;
    
    if (isUpdate) {
      console.log('🔄 Updating existing quotation:', quotationData._id);
    } else {
      console.log('🆕 Creating new quotation');
      // Get cart items from state (only for new quotations)
      if (!cartItems.length) {
        return { success: false, message: 'Your Bucket is empty' };
      }
    }

  
    // Get userData from sessionStorage
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const material_requirement = JSON.parse(localStorage.getItem('material_requirement'));
    const customerId = userData?._id;
    const token = userData?.token;
    const hubId = userData?.hubId;

    if (!customerId || !token || !hubId) {
      return { success: false, message: 'User information is incomplete or missing' };
    }

    let quotationPayload;

    if (isUpdate) {
      // Prepare UPDATE quotation data
      quotationPayload = {
        quotation_id: quotationData._id,
        quotation_number: quotationData.quotation_number,
        quotation_date: quotationData.quotation_date,
        customer_id: quotationData.customer_id._id,
        delivery_address_id: selectedDeliveryAddress?._id || quotationData.delivery_address_id,
        tax_prefrence: "Taxable",
        hubId: quotationData.hubId,
        status: "Pending", 
        is_digistore: true,

        // Use updated quotation items
        items: quotationData.product_categories.flatMap(category =>
          category.items.map(item => ({
            item_id: item.item_id,
            item_image: item.item_image,
            item_name: item.item_name,
            quantity: item.quantity,
            initial_price: item.initial_price,
            selling_price: item.selling_price,
            cost_price: item.cost_price,
            tax_rate: item.tax_rate,
            total_tax_amount: item.total_tax_amount,
            total: item.total,
            UOM_id: item.UOM_id,
          }))
        ),
       
        subtotal: Math.round(quotationData.subtotal),
        tax_amount: Math.round(quotationData.tax_amount),
        discount: discount,
        total: Math.round(quotationData.total - discount),
        terms_and_conditions: "Standard terms and conditions apply",
        suggest_alternatives:true
      };
    } else {
         
// Calculate total amount including tax and discount
const totalAmount = cartTotal - (redeemableCoins > 0 ? redeemableCoins : 0) + TaxAmount;
// Extract unique product category IDs from cart items
 const product_category_ids = [
  ...new Set(cartItems.map(item => item.product_category_id))
];
// Build quotation payload
 quotationPayload = {
  quotation_date: new Date().toISOString(),
  customer_id: customerId,
  project_id: projectId || null,
  delivery_address_id: selectedDeliveryAddress?._id || null,
  tax_preference: "Taxable",
  hubId: hubId,
  status: "Pending",
  is_digistore: true,

  // Map cart items into quotation items
  items: cartItems.map(item => {
    const totalPrice = item.selling_price * item.quantity;
    const taxRate = item.GST / 100;
    const totalTaxAmount = totalPrice * taxRate;
    const totalItemAmount = totalPrice + totalTaxAmount;

    return {
      item_id: item._id,
      item_image: item.product_image,
      item_name: item.product_name,
      quantity: item.quantity,
      selling_price: item.selling_price,
      cost_price: Math.round(+(item.selling_price * 0.8)), // optional cost calculation
      tax_rate: Math.round(taxRate),
      total_tax_amount: Math.round(+totalTaxAmount),
      total: Math.round(+totalItemAmount),
      UOM_id: item?.UOM_id,
    };
  }),


  product_category_ids: product_category_ids,
  subtotal: cartTotal,
  tax_amount: TaxAmount,
  discount: redeemableCoins > 0 ? redeemableCoins : 0,
  total: totalAmount ,
  terms_and_conditions: "Standard terms and conditions apply",
  suggest_alternatives:true
};

console.log('Constructed quotation payload:', quotationPayload);
console.log('product_category_ids:', product_category_ids);

    }

    if(material_requirement && material_requirement?.material_requirement_id && material_requirement?.MR_items_id){
      quotationPayload.material_requirement_id = material_requirement.material_requirement_id 
      quotationPayload.MR_items_id = material_requirement.MR_items_id 
    }

    console.log('📤 Sending quotation data:', quotationPayload);

    const endpoint = `${fetchUrl}customer/quotations/save-quickbuy-quotation`;
    const method = 'POST';

    // Send to backend
    const response = await fetch(endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(quotationPayload)
    });

    const data = await response.json();
    console.log('📊 Backend response:', data);

    if (data.success) {
      const coinsString = sessionStorage.getItem('coinData');
      let buildcoins;
      if (coinsString) {
        const coins = JSON.parse(coinsString);
        buildcoins = coins.coins;
        console.log(buildcoins);
      } else {
        console.log('No coin data found in sessionStorage.');
      }

      const finalQuotationId = isUpdate ? quotationData._id : data.data._id;
      console.log('💰 Final quotation ID:', finalQuotationId);

      if (discount) {
       // applyBuildCoinsFromWallet(coinLedger?._id, finalQuotationId);
      }

      localStorage.removeItem('cartItems');
      localStorage.removeItem('bucketQuantities');
      localStorage.removeItem('bucketImages');
      localStorage.removeItem('bucketProducts');
      localStorage.removeItem('material_requirement');

      let savedItems = JSON.parse(sessionStorage.getItem("savedItems")) || [];
savedItems = savedItems.map(item => ({ ...item, quantity: 0 }));
sessionStorage.setItem("savedItems", JSON.stringify(savedItems));


navigate("/consumer/projectdetails", { replace: true });

// 2️⃣ Then go to RFQDetails cleanly
setTimeout(() => {
  navigate("/consumer/app/rfqdetails", {
    state: {
      from: "cart",
      rfq_id: data.data.RFQ_id,
      quotationId: finalQuotationId
    }
  });
}, 50);


      return { 
        success: true, 
        quotationNumber: isUpdate ? quotationData.quotation_number : data.data.quotation_number 
      };

    } else {
      return { success: false, message: data.message || 'Failed to process quotation' };
    }

  } catch (error) {
    console.error('Error processing quotation:', error);
    return { success: false, message: 'An error occurred while processing the quotation' };
  }
};


const fetchProjectsByCustomerId = async () => {
  
  try {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    if (!customerId || !token) {
      console.error(' Customer ID or token not found in session storage');
      return;
    }

   const apiUrl = `${process.env.REACT_APP_FORE_APILINK}/projects/get-projects-by-customer?customer_id=${customerId}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });
    const data = await response.json();
    console.log(' Response data:', data);
    
    if (data.success) {
      setProjects(data.data || []);
    } else {
      console.error(' Failed to fetch projects:', data.message);
    }
  } catch (error) {
    console.error(' Error in fetchProjectsByCustomerId:', error);
   
  }
  
};


if (loading) {  
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400  text-xs">Loading Bucket...!</p>
    </div>
  );
}


const handleProductClick = (item) => {
  const productData = {
    _id: item._id,
    product_name: item.product_name,
    product_image: item.product_image,
    product_description: item.product_description || "",
    selling_price: item.selling_price || 0,
    UOM_id: item.UOM_id || { UOM: "No" },
    specifications: item.specifications || "[]",
    tax_preference: item.tax_preference || "",
    GST: item.GST || 0,
    IGST: item.IGST || 0,
    SKU: item.SKU || "",
    HSN_Code: item.HSN_Code || "",
    cost_price: item.cost_price || 0,
    hubIds: item.hubIds || [],
    is_active: item.is_active !== undefined ? item.is_active : true,
    vendor_id: item.vendor_id || "",
    product_category_id: item.product_category_id,
    product_category_name: item.product_category_name,
  };

  console.log("🟢 Navigating to ProductInformation with:", productData);

  navigate("/consumer/productInformation", {
    state: {
      product: productData,
      vendor_id: productData.vendor_id,
      relatedProducts: [],
    },
  });
};


const handleQuotationQuantityChange = (categoryIndex, itemIndex, action) => {
  if (!quotationData || !quotationData.product_categories) return;

  const updatedQuotationData = { ...quotationData };
  const item = updatedQuotationData.product_categories[categoryIndex].items[itemIndex];

  if (action === 'increase') {
    item.quantity += 1;
  } else if (action === 'decrease' && item.quantity > 1) {
    item.quantity -= 1;
  }

  // Recalculate item totals
  item.line_total = item.selling_price * item.quantity;
  item.total_tax_amount = (item.line_total * item.tax_rate) / 100;
  item.total = item.line_total + item.total_tax_amount;

  // Recalculate quotation totals
  const allItems = updatedQuotationData.product_categories.flatMap(cat => cat.items);
  updatedQuotationData.subtotal = allItems.reduce((sum, item) => sum + item.line_total, 0);
  updatedQuotationData.tax_amount = allItems.reduce((sum, item) => sum + item.total_tax_amount, 0);
  updatedQuotationData.total = updatedQuotationData.subtotal + updatedQuotationData.tax_amount;

  setQuotationData(updatedQuotationData);
  console.log('📊 Updated quotation:', updatedQuotationData);
};
 
const handleQuotationRemoveItem = (categoryIndex, itemIndex) => {
  if (!quotationData || !quotationData.product_categories) return;

  const updatedQuotationData = { ...quotationData };
  
  // Remove the item from the category
  updatedQuotationData.product_categories[categoryIndex].items.splice(itemIndex, 1);
  
  // Remove empty categories
  updatedQuotationData.product_categories = updatedQuotationData.product_categories.filter(
    category => category.items.length > 0
  );

  // Recalculate quotation totals
  const allItems = updatedQuotationData.product_categories.flatMap(cat => cat.items);
  updatedQuotationData.subtotal = allItems.reduce((sum, item) => sum + item.line_total, 0);
  updatedQuotationData.tax_amount = allItems.reduce((sum, item) => sum + item.total_tax_amount, 0);
  updatedQuotationData.total = updatedQuotationData.subtotal + updatedQuotationData.tax_amount;

  setQuotationData(updatedQuotationData);
  console.log('🗑️ Item removed, updated quotation:', updatedQuotationData);
};


const confirmDeleteItem = () => {
  performRemoveItem(pendingRemoveItem._id);
  setShowDeleteBottomSheet(false);
};

// Function to save item to sessionStorage
const handleSaveItem = () => {
  const savedItems = JSON.parse(sessionStorage.getItem("savedItems")) || [];
  const exists = savedItems.some(
    (i) => i.id === pendingRemoveItem._id  
  );
  if (!exists) {
    savedItems.push({
      id: pendingRemoveItem._id,
      name: pendingRemoveItem.product_name,
      image: imageUrl + pendingRemoveItem.product_image,
      price: pendingRemoveItem.selling_price,
       uom: pendingRemoveItem.UOM_id?.UOM || pendingRemoveItem.uom || null,
      categoryId: pendingRemoveItem.product_category_id,
      quantity: pendingRemoveItem.quantity, 
    });
    sessionStorage.setItem("savedItems", JSON.stringify(savedItems));
  }
  navigate("/consumer/savedItems");
};



 return (
    <div className="min-h-screen flex flex-col bg-gray-100 pb-20">
  {/* Custom Header */}
 
        <HeaderBar
         title="My Bucket" 
        onShareClick={handleShareClick}
          showSearch={true}
  onSearchClick={() => setIsProductSearchOpen(true)}
   />


  {/* Note Section - Sticky below header */}
   {cartItems.length > 0 && (
        <>
      <div className="bg-gradient-to-r from-white to-gray-50 p-3 my-2 rounded-r-md shadow-sm border border-gray-100 sticky top-12 z-20">
    <div className="flex items-start gap-2">
     
      <div className="text-gray-800">
        <span className="text-blue-600 font-bold text-sm">NOTE :</span>{" "}
        <span className="font-semibold text-sm">
          The Prices shown below are <span className="font-bold">Estimates only</span>.{' '} 
          <span className="font-bold">Get Final and Best price</span> by requesting final quote.
        </span>
      </div>
    </div>
  </div>
        </>
      )}
 

 
 {quotationData && (
   <div className="mx-6 mt-3">
     <div className="flex justify-between items-center mb-1">
       <h3 className="text-lg font-semibold text-[#000000]">
         Order ID
       </h3>
       <span className="text-lg font-semibold text-[#000000]">
         {quotationData.quotation_number}
       </span>
     </div>
   </div>
 )}
  
 
 {/* Order Details Section */}
 <div className="mx-4 mb-4 mt-3">
   {quotationData && quotationData.product_categories ? (
     quotationData.product_categories.map((category, categoryIndex) => {
       const categoryTotal = category.items.reduce((total, item) => 
         total + (item.initial_price * item.quantity), 0
       );
       
       return (
         <div key={category.product_category_id} className="bg-white rounded-md shadow-sm p-4 mb-2">
           <div className="flex justify-between items-center mb-3">
             <h3 className="text-sm font-semibold text-[#000000]">
               {category.product_category_name}
             </h3>
             <div className="flex items-center">
               <span className="text-sm font-semibold text-[#170101]">
                 ₹{categoryTotal.toLocaleString()}
               </span>
             </div>
           </div>
           
           <div className="border-b border-gray-200 mb-3"></div>
           
           <div className="space-y-3">
             {category.items.map((item, itemIndex) => (
               <div key={item.item_id} className="flex items-start">
                 <div className="bg-gray-100 rounded-md p-2 mr-3 flex-shrink-0 h-12 w-12 flex items-center justify-center relative">
   <img
     src={imageUrl + item.image}
     alt={item.name}
     className="h-full w-full object-contain absolute"
     onError={(e) => {
       e.target.style.display = 'none';
       e.target.parentNode.innerHTML += '<span class="text-gray-400 text-center text-xs">No Image</span>';
     }}
   />
 </div>
 
                 
                 <div className="flex-1 min-w-0">
                   <div className="text-[13px] text-[#000000] leading-tight mt-2">
                     {item.item_name}
                   </div>
                 <div className="text-[13px] text-[#000000] leading-tight mt-2">
                   {redeemableItems?.length > 0 && (() => {
                     const matchedItem = redeemableItems.find(
                       i =>
                         i.item_id?.toString() === item.item_id?.toString() ||
                         i.item_id?.toString() === item._id?.toString()
                     );
 
                     // Only render if matchedItem exists and has coins
                     if (matchedItem && matchedItem.coins > 0) {
                       const netPrice = item.selling_price * item.quantity - matchedItem.coins;
                       return (
                         <span className="text-green-600 text-xs font-semibold ml-1">
                           ₹{netPrice} + {matchedItem.coins}
                           <img
                             src={BuildCoin}
                             alt="BuildCoin"
                             className="h-4 w-4 inline-block ml-1"
                           />
                         </span>
                       );
                     }
 
                     // Return null if no coins
                     return null;
                   })()}
                 </div>
                   <button
                     className="text-[13px] text-[#D93025] font-medium mb-0.5"
                     onClick={() => handleQuotationRemoveItem(categoryIndex, itemIndex)}
                   >
                     remove
                   </button>
                 </div>
                 
                 <div className="flex flex-col items-end ml-3 mt-2">
                   <div className="flex items-center border border-red-500 rounded-md mb-1">
                     <button
                       className="w-6 h-6 flex items-center justify-center text-red-500 text-sm"
                       onClick={() => handleQuotationQuantityChange(categoryIndex, itemIndex, 'decrease')}
                     >
                       -
                     </button>
                     <span className="px-2 py-0.5 text-sm">{item.quantity}</span>
                     <button
                       className="w-6 h-6 flex items-center justify-center text-red-500 text-sm"
                       onClick={() => handleQuotationQuantityChange(categoryIndex, itemIndex, 'increase')}
                     >
                       +
                     </button>
                   </div>
                   <div className="text-[13px] font-medium text-[#170101] mt-1">
                     ₹{(item.initial_price * item.quantity).toLocaleString()}
                   </div>
                 </div>
               </div>
             ))}
           </div>
         </div>
       );
     })
   ) : (
    categories.length > 0 ? (() => {
   const groupedItems = groupItemsByCategory(cartItems, categories);
 
   return Object.entries(groupedItems).map(([categoryName, items]) => {
     const categoryTotal = items.reduce(
       (total, item) => total + item.selling_price * item.quantity,
       0
     );
 
     return (
       <div key={categoryName} className="bg-white rounded-md shadow-sm px-4 py-1 mb-3">
         {/* Category Header */}
         <div className="flex justify-between  items-center mb-1 py-1">
           <h3 className="text-sm  flex justify-center font-semibold text-gray-700">{categoryName}</h3>
         {/*   <span className="text-sm font-semibold text-[#170101]">
             ₹{categoryTotal.toLocaleString()}
           </span> */}
         </div>
 
         <div className="border-b border-gray-200 mb-3"></div>
 
         {/* Items in Category */}
         <div className="space-y-3">
           {items.map((item, index) => (
      <div
   key={item._id}
   className={`flex items-start bg-white  mb-3 relative ${items.length === index + 1? '': 'border-b border-gray-200 pb-1'}`}
 >
   {/* Product Image & Remove Button Container */}
   <div className="flex-shrink-0">
     {/* Product Image with gray border */}
     <div className="p-1 relative w-14 h-14 bg-gray-100 rounded-md flex items-center justify-center overflow-hidden mb-2 border border-gray-300"
       onClick={() => handleProductClick(item)}
      >
     <img
    src={
      item.product_image
        ? imageUrl + item.product_image
        : defaultimg
    }
    alt={item.product_name}
    className="h-full w-full object-contain"
    onError={(e) => {
      e.currentTarget.src = defaultimg;
    }}
  />

     </div>
 
     {/* Remove Button - Now under the image */}
    <button
  className="text-[11px] text-[#D93025] font-medium mt-1"
  onClick={() => {
    setPendingRemoveItem(item);
    setShowDeleteBottomSheet(true);
  }}
>
  Remove
</button>
   </div>
 
   {/* Product Info */}
   <div className="flex-1 px-3 min-w-0">
  
  {/* Product Name - 2 line truncate */}
  <div
    className="text-sm font-semibold text-gray-1000 line-clamp-2 leading-tight mb-1"
    onClick={() => handleProductClick(item)}
  >
    {item.product_name}
  </div>

 <div className="text-xs text-gray-500">
  {(() => {
    const u = allUOMs.find(u => u._id === item.UOM_id)?.UOM;
    return u ? `₹${item.selling_price.toLocaleString('en-US')} / ${u}` : `₹${item.selling_price.toLocaleString('en-US')}`;
  })()}
</div>




</div>

 
   {/* Quantity Controls - Moved to right corner with slight gap */}
   <div className="flex flex-col items-end space-y-1 flex-shrink-0 mr-1">
     <div className="flex items-center border border-gray-300 rounded-md overflow-hidden min-w-[100px]">
       <button
         className="font-extrabold w-7 h-8 flex items-center justify-center text-red-500 text-sm"
         onClick={() => handleQuantityChange(item._id, 'decrease')}
       >
         −
       </button>
       <div className='h-6 w-px bg-gray-300'></div>
   <input
  type="text"
  inputMode="numeric"
  ref={qtyInputRef}
  value={item.quantity}

  onFocus={() => {
    isQtyFocused.current = true;
    focusedItemIdRef.current = item._id;
    lastValidQtyRef.current = item.quantity;   // store previous qty
  }}

  onChange={(e) => {
    let v = e.target.value.replace(/\D/g, "");
    currentQtyRef.current = v;                 // store current typed qty
    handleMainProductQuantityInputChange(item._id, v);
  }}

  className="px-auto mx-auto font-bold w-7 text-center text-sm text-gray-700 border-0 bg-transparent focus:outline-none focus:ring-0 [-webkit-tap-highlight-color:transparent]"
/>


       <div className='h-6 w-px bg-gray-300'></div>
       <button
         className=" font-extrabold w-7 h-8 flex items-center justify-center text-red-500 text-sm"
         onClick={() => handleQuantityChange(item._id, 'increase')}
       >
         +
       </button>
     </div>
   </div>
 
 {/* {redeemableItems?.length > 0 ? (
       <div className="absolute bottom-1 right-2 text-md font-semibold text-gray-700 whitespace-nowrap">
 ₹{(item.selling_price * item.quantity).toLocaleString()}
     </div>
 ) : (
 
   <div className="line-through absolute bottom-8 right-3 text-xs font-semibold text-gray-500 whitespace-nowrap">
     ₹{(item.selling_price * item.quantity).toLocaleString()}
   </div>
 )} */}
 
 {(() => {
   if (redeemableItems?.length > 0) {
     // Find the matched redeemable item for this item
     const matchedItem = redeemableItems.find(
       (i) =>
         i.item_id?.toString() === item.item_id?.toString() ||
         i.item_id?.toString() === item._id?.toString()
     );
 
     if (matchedItem && matchedItem.coins > 0) {
       const netPrice = item.selling_price * item.quantity - matchedItem.coins;
 
       return (
         <>
           {/* Original price line-through */}
           <div className="line-through absolute bottom-8 right-2 text-xs font-semibold text-gray-500 whitespace-nowrap">
             ₹{(item.selling_price * item.quantity).toLocaleString()}
           </div>
 
           {/* Net price after redeeming coins */}
           <div className="whitespace-nowrap absolute bottom-1 right-1 text-md text-green-600 font-bold flex items-center">
             <span className="font-bold text-gray-700 mr-1">
               ₹{netPrice.toLocaleString()} +
             </span> 
             {matchedItem.coins}
             <img src={BuildCoin} alt="BuildCoin" className="h-4 w-5 inline-block" />
           </div>
         </>
       );
     } else {
       // No matched coins, show normal price
       return (
         <div className="absolute bottom-3 right-2 text-md font-bold text-gray-700 whitespace-nowrap">
           ₹{(item.selling_price * item.quantity).toLocaleString()}
         </div>
       );
     }
   } else {
     // No redeemable items -> show line-through original price
     return (
      <>
      {/*  <div className="line-through absolute bottom-8 right-3 text-xs font-semibold text-gray-500 whitespace-nowrap">
         ₹{(item.selling_price * item.quantity).toLocaleString()}
       </div> */}
       <div className="absolute bottom-3 right-2 text-md font-bold text-gray-700 whitespace-nowrap">
           ₹{(item.selling_price * item.quantity).toLocaleString()}
         </div>
      </>
      
     );
   }
 })()}
 
 
 
    {/* Redeemable Coin Logic */}
    {/*  {redeemableItems?.length > 0 && (() => {
       //console.log(redeemableItems);
       const matchedItem = redeemableItems.find(
         (i) =>
           i.item_id?.toString() === item.item_id?.toString() ||
           i.item_id?.toString() === item._id?.toString()
       );
 
       if (matchedItem && matchedItem.coins > 0) {
         const netPrice = item.selling_price * item.quantity - matchedItem.coins;
         return (
           <div className="whitespace-nowrap absolute bottom-1 right-2 text-md text-green-600 font-semibold flex items-center">
            <span className='font-bold text-gray-700 mr-1 '> ₹{netPrice} + </span>
            {matchedItem.coins}
             <img
               src={BuildCoin}
               alt="BuildCoin"
               className="h-4 w-5  inline-block"
             />
           </div>
         );
       }
       return null;
     })()} */}
 </div>
 
           ))}
         </div>
       </div>
     );
   });
 })() : (
  <>
  {/*  {categories.length > 0 && (
   <div className="bg-white rounded-md shadow-sm p-4">
     <div className="space-y-3">
       {cartItems.map(item => (
        <div
   key={item._id}
   className="flex items-start justify-between py-2 border-b border-gray-100"
 >

   <div className="flex flex-col items-center w-14">
     <div className="bg-gray-100 rounded-md p-2 h-12 w-12 flex items-center justify-center relative"
      onClick={() => handleProductClick(item)}
      >
       {item.product_image ? (
         <img
           src={imageUrl + item.product_image}
           alt={item.product_name}
           className="h-full w-full object-contain absolute"
           onError={(e) => {
             e.target.style.display = 'none';
             e.target.parentNode.innerHTML +=
               '<span class="text-gray-400 text-center text-[10px]">No Image</span>';
           }}
         />
       ) : (
         <span className="text-gray-400 text-center text-[10px]">No Image</span>
       )}
     </div>
 
     <button
       className="text-[11px] text-[#D93025] font-medium mt-1"
       onClick={() => handleRemoveItem(item._id)}
     >
       Remove
     </button>
   </div>
 
   <div className="flex-1 flex justify-between items-center ml-3">
 
     <div className="min-w-0 flex-1 pr-2">
       <div className="text-[13px] text-[#000000] font-medium leading-tight truncate"
       onClick={() => handleProductClick(item)}
       >
         {item.product_name}
       </div>
     </div>
 
     <div className="flex flex-col items-end">
       <div className="flex items-center border border-red-500 rounded-md mb-1">
         <button
           className="w-6 h-6 flex items-center justify-center text-red-500 text-sm"
           onClick={() => handleQuantityChange(item._id, "decrease")}
         >
           −
         </button>
         <span className="px-2 py-0.5 text-sm">{item.quantity}</span>
         <button
           className="w-6 h-6 flex items-center justify-center text-red-500 text-sm"
           onClick={() => handleQuantityChange(item._id, "increase")}
         >
           +
         </button>
       </div>
       <div className="text-xs font-bold text-[#170101]">
         ₹{(item.selling_price * item.quantity).toLocaleString()}
       </div>
     </div>
   </div>
 </div>
 
       ))}
     </div>
   </div>
     )} */}
     </>
 )
   )}
 </div>
 
 
 {/* Bill Details Section */}
 <div className="mx-4 mb-2">
   {((quotationData && quotationData.product_categories && quotationData.product_categories.length > 0) || (cartItems && cartItems.length > 0)) ? (
     <div className="bg-white rounded-md p-4 shadow-sm">
       <h3 className="text-lg font-bold text-[#524D4D] mb-2">Estimated Bill</h3>
       
       {/* Item Total */}
       <div className="flex justify-between items-center py-1">
         <div className="flex items-center">
           <img src={ListView} alt="Items" className="h-3 w-4 mr-1" />
           <span className="text-[13px] text-[#000000]">Subtotal</span>
         </div>
         <span className="text-sm text-[#170101]">
           ₹{quotationData ? Math.round(quotationData.subtotal).toLocaleString() : cartTotal.toLocaleString()}
         </span>
       </div>
       
       {/* Delivery Charge */}
       {/* <div className="flex justify-between items-start py-2 mr-1">
         <div className="flex items-start">
           <img src={DeliveFood} alt="Delivery" className="h-4 w-5" />
           <span className="text-[13px] text-[#00000] ">Delivery Charge</span>
         </div>
         <span className="text-sm text-[#170101]">₹200</span>
       </div> */}
       
       {/* Red text below delivery charge */}
       {/* <div className="text-[11px] text-[#C20C0C] mb-2 font-semibold ml-1">
         Delivery charges are relative and may change after the supplier accepts the order
       </div>
        */}
     
         {/* checked && */ redeemableCoins > 0 && (
         <div className="flex justify-between items-start py-1">
           <div className="flex items-start">
             <img src={BuildCoin} alt="BuildCoin" className="h-4 w-4" />
             <span className="text-[13px] text-green-700"> Est. BuildCoins Discount</span>
           </div>
           <span className="text-sm text-[#14A311]">- ₹{redeemableCoins}</span>
         </div>
         )}
     
 
      
 
       
       {/* Handling Charge */}
       {/* <div className="flex justify-between items-start py-1">
         <div className="flex items-start">
           <img src={ManualHandling} alt="Handling" className="h-4 w-5 mr-1" />
           <span className="text-[13px] text-[#00000]">Handling Charge</span>
         </div>
         <span className="text-sm text-[#170101]">₹10</span>
       </div> */}
       
       {/* GST */}
       <div className="flex justify-between items-start py-1">
         <div className="flex items-start">
           <img src={File} alt="GST" className="h-4 w-4 mr-1" />
           <span className="text-[13px] text-[#00000]">Tax</span>
         </div>
         <span className="text-sm text-[#170101]">
          ₹{quotationData 
            ? Math.round(quotationData.tax_amount).toLocaleString('en-US') 
           : Math.round(TaxAmount).toLocaleString('en-US')
           } 
         </span>
       </div>
       
       {/* Separator Line */}
       <div className="border-t border-gray-200 my-2"></div>
       
       {/* Grand Total */}
       <div className="flex justify-between items-center py-2">
         <span className="text-md font-bold text-[#524D4D]"> Total</span>
         <span className="text-md font-semibold text-[#170101]">
         ₹{quotationData 
          ? Math.round(quotationData.total - redeemableCoins).toLocaleString('en-US') 
         : Math.round(cartTotal + TaxAmount - (redeemableCoins > 0 ? redeemableCoins : 0)).toLocaleString('en-US')
            }
         </span>
       </div> 
     </div>
   ) : (
     // Empty State UI for No Items
     <div className="bg-white rounded-md p-6 shadow-sm text-center">
       <div className="flex flex-col items-center space-y-3">
         {/* Optional Icon - Assuming you have an empty cart icon; replace with actual import */}
         <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto">
          {/*  <span className="text-gray-400 text-2xl">🛒</span>  */}{/* Emoji fallback; use SVG/icon component */}
          <img src={Bucket} alt="Bucket" className="h-8 w-8 object-contain" />
         </div>
         <h3 className="text-lg font-semibold text-[#524D4D]">No items in your Bucket</h3>
         <p className="text-sm text-gray-600">Add items to your bucket to see the estimated bill and proceed with your order.</p>
         {/* Optional CTA Button - Link to products page; customize onClick */}
         <button 
           className="bg-[#D93025] text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-red-700 transition-colors"
           onClick={() => {navigate('/consumer/productCategories');}}
         >
           Add Items to Bucket
         </button>
       </div>
     </div>
   )}
 </div>

 

 

{/* Delivery Timings Section - Only show when there are items */}
{((quotationData && quotationData.product_categories && quotationData.product_categories.length > 0) || (cartItems && cartItems.length > 0)) && (
  <div className="mx-4 my-4 bg-white rounded-xl shadow-sm overflow-hidden">
    {/* Header */}
    <div className="flex items-center gap-2 px-4 py-2.5 border-b border-gray-100">
      <h2 className="text-[#524D4D] font-semibold text-lg tracking-wide mt-2">
        Delivery Details
      </h2>
    </div>

    {/* Content */}
    <div className="p-3.5 space-y-3.5 text-gray-800">
      {/* Row 1 */}
      <div className="flex items-start gap-2.5">
        <div className="w-7 h-7 flex justify-center items-center rounded-full bg-blue-50 text-blue-600">
          <FontAwesomeIcon icon={faClock} className="text-[13px]" />
        </div>

        <div className="flex-1">
          <div className="flex flex-col gap-0.5">
            <p className="font-semibold text-gray-900 text-[13.5px] leading-tight">
              Orders Confirmed Between
            </p>

            <div className="flex items-center justify-between">
              <p className="text-blue-600 font-medium text-[13.5px]">
                9:30 AM – 1:00 PM
              </p>
              <span className="text-[10px] bg-blue-100 text-blue-700 px-1.5 py-[2px] rounded-md font-medium">
                Same-day
              </span>
            </div>

            {/* Delivery Slot Section with Truck Icon */}
            <div className="mt-1 flex items-center gap-1.5">
              <FontAwesomeIcon icon={faTruck} className="text-sm text-gray-500" />
              <p className="text-[12.5px] text-gray-600 leading-tight">
                Delivered between
              </p>
            </div>
            <p className="font-semibold text-gray-900 text-[13.5px] mt-0.5 ml-5">
              2:00 PM – 7:00 PM
            </p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-100 mx-1"></div>

      {/* Row 2 */}
      <div className="flex items-start gap-2.5">
        <div className="w-7 h-7 flex justify-center items-center rounded-full bg-green-50 text-green-600">
          <FontAwesomeIcon icon={faCalendarCheck} className="text-[13px]" />
        </div>

        <div className="flex-1">
          <div className="flex flex-col gap-0.5">
            <p className="font-semibold text-gray-900 text-[13.5px] leading-tight">
              Order Confirmed Between
            </p>

            <div className="flex items-center justify-between">
              <p className="text-green-600 font-medium text-[13.5px]">
                13:00 PM – 19:00 PM
              </p>
              <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-[2px] rounded-md font-medium">
                Next-day
              </span>
            </div>

            {/* Delivery Slot Section with Truck Icon */}
            <div className="mt-1 flex items-center gap-1.5">
              <FontAwesomeIcon icon={faTruck} className="text-sm text-gray-500" />
              <p className="text-[12.5px] text-gray-600 leading-tight">
                Delivered nextday between
              </p>
            </div>
            <p className="font-semibold text-gray-900 text-[13.5px] mt-0.5 ml-5">
              9:30 AM – 13:00 PM
            </p>
          </div>
        </div>
      </div>

      {/* Note */}
      <div className="mt-1.5 bg-amber-50 border border-amber-100 rounded-md p-2 flex items-start gap-2">
        <FontAwesomeIcon icon={faInfoCircle} className="text-amber-600 text-[12.5px] mt-0.5" />
        <p className="text-[12.5px] text-gray-800 leading-snug">
          Actual delivery cost will be shown on receiving final quote.
        </p>
      </div>
    </div>
  </div>
)}





 {/* Delivery Address Section - Separate, not sticky */}
 {((quotationData && quotationData.product_categories && quotationData.product_categories.length > 0) || (cartItems && cartItems.length > 0)) && (
 <div className="mx-4 mb-10 mt-2">
   <div className="bg-white rounded-md shadow-sm overflow-hidden">
    <div 
       className="flex items-center p-2 cursor-pointer hover:bg-gray-50 transition-colors"
     >
       {/* Conditional Icon */}
       <div className="flex-shrink-0 mr-2">
         <div className="w-12 h-10 flex items-center justify-center">
           {selectedDeliveryAddress ? (
             // Show selected delivery address icon
             <div className="bg-[#F5F5F5] rounded-md w-10 h-10 flex items-center justify-center">
               {selectedDeliveryAddress.address_type === 'project' ? (
                 <img
                   src={Building}
                   alt="Project"
                   className="h-6 w-6 object-contain"
                 />
               ) : (
                 <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                 </svg>
               )}
             </div>
           ) : (
             // Show Map image when no address selected
             <div className="bg-[#F5F5F5] rounded-md w-10 h-10 flex items-center justify-center">
               <img
                 src={Map}
                 alt="Map"
                 className="h-6 w-6 object-contain"
               />
             </div>
           )}
         </div>
       </div>
 
       {/* Conditional Content */}
       {selectedDeliveryAddress ? (
         // Show selected delivery address data
         <>
           {/* Address Details */}
           <div className="flex-1">
             <p className="text-sm text-[#000000]">
               Delivering to <span className='text-[#000000] font-semibold'>
                 {selectedDeliveryAddress.address_type === 'project' ? 'Project' : 'Address'}
               </span>
             </p>
             <p className="text-xs text-[#666666]">
               {selectedDeliveryAddress.address_type === 'project' && selectedDeliveryAddress.project_name && 
                 `${selectedDeliveryAddress.project_name}, `
               }
               {selectedDeliveryAddress.area_sector_locality?.length > 45
                 ? `${selectedDeliveryAddress.area_sector_locality.substring(0, 45)}...`
                 : selectedDeliveryAddress.area_sector_locality
               }
             </p>
           </div>
 
           {/* Change Button */}
           <button
             className="text-[#F43042] text-xs font-semibold px-3 py-1 rounded-md transition-colors"
             onClick={() => setShowLocationPopup(true)}
           >
             Change
           </button>
         </>
       ) : (
         // Show choose delivery address if no address selected
         <>
           {/* Address Text */}
           <div className="flex-1">
             <p className="text-sm font-semibold text-gray-800">Choose delivery address</p>
           </div>
 
           {/* Choose Button */}
           <button
             className="text-[#1A73E7] text-sm font-semibold px-3 py-1 rounded-md transition-colors"
             onClick={() => setShowLocationPopup(true)}
           >
             Choose
           </button>
         </>
       )}
     </div>
   </div>
 </div>
 )}
 
 {/* Saved BuildCoins Card - Only show if redeemableCoins > 0 */}
 
 {(Number(redeemableCoins) > 0 || Number(rewardableCoins) > 0) && (
  <div className="fixed bottom-16 left-0 right-0 z-50 flex justify-center pointer-events-none">
    <div className=" overflow-hidden flex flex-col w-full max-w-md mx-auto pointer-events-auto">
      <motion.div 
        className="bg-gradient-to-r from-green-600 to-green-500 shadow-md flex flex-wrap items-center justify-center px-3 py-2 gap-2"
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.3 }}
      >

       <span className="text-white text-md font-medium flex flex-wrap items-center gap-1">
  {Number(redeemableCoins) > 0 && Number(rewardableCoins) > 0 ? (
    // Both redeemableCoins and rewardableCoins are present
    <>
      <span className='font-bold'>Save</span>upto {" "}
      <span className="font-bold text-base flex items-center">
        ₹ {redeemableCoins}
      </span>{" "}
      & <span className='font-bold'> Earn </span> upto {" "}
      <span className="font-bold text-base flex items-center">
        {rewardableCoins}
        <img
          src={BuildCoin}
          alt="BuildCoin"
          className="h-5 w-5 ml-1 inline-block"
        />
      </span>{" "}
      
    </>
  ) : Number(redeemableCoins) > 0 ? (
    // Only redeemableCoins is present
    <>
      you may <span className="font-bold">Save upto</span>{" "}
      <span className="font-bold text-base flex items-center">
        ₹{redeemableCoins}
      </span>
    </>
  ) : Number(rewardableCoins) > 0 ? (
    // Only rewardableCoins is present
    <>
      You <span className="font-bold">earn upto</span>{" "}
      <span className="font-bold text-base flex items-center">
        {rewardableCoins}
        <img
          src={BuildCoin}
          alt="BuildCoin"
          className="h-5 w-5 ml-1 inline-block"
        />
      </span>
    </>
  ) : null}
</span>


      </motion.div>
    </div>
  </div>
)}

 
 
 
 {/* Total Section - Sticky Bottom */}
 {((quotationData && quotationData.product_categories && quotationData.product_categories.length > 0) || (cartItems && cartItems.length > 0)) && (
 <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
   <div className="px-6 py-2 flex justify-between items-center">
   <div className="flex flex-col">
   <span className="text-sm text-gray-500 font-medium tracking-wide">Estimated Total</span>
   <span className="text-xl md:text-lg font-bold text-gray-900 mt-1">
     ₹{quotationData 
       ? (quotationData.total - redeemableCoins).toLocaleString('en-US')
       : (cartTotal - (redeemableCoins > 0 ? redeemableCoins : 0) + TaxAmount).toLocaleString('en-US') /* (cartTotal + Math.round(cartTotal * 0.18) - (checked ? redeemableCoins : 0)).toLocaleString() */
     }
   </span>
   {checked && redeemableCoins > 0 && (
     <span className="text-xs text-green-600 font-medium mt-0.5">
       ₹{redeemableCoins.toLocaleString()} discount applied
     </span>
   )}
 </div>
 
     
     {/* <button
       className="px-4 py-2 bg-[#F43042] text-white rounded-md font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
       onClick={handleConfirmation}
       disabled={showOrderPlacedPopup}
     >
       Request For Final Quote
     </button> */}
 
     <button
  className="px-5 py-3 bg-[#F43042] text-white rounded-lg font-semibold shadow-md hover:shadow-lg hover:scale-105 transition-transform duration-200 pointer-events-auto"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPopup(true);
  }}
>
  Request Final Quote
</button>
 
   </div>
 </div>
 )}
 
 
 {showLocationPopup && (
   <>
   <ChangeLocationPopup
    deliveryAddresses = {deliveryAddresses}
    deliveryAddress = {selectedDeliveryAddress}
    setDeliveryAddress= {setSelectedDeliveryAddress}
    setShowLocationPopup = {setShowLocationPopup}
   />
   </>
 )}
 
 
 {/* Share Popup */}
 {showSharePopup && (
   <>
     {/* Backdrop */}
     <div 
       className="fixed inset-0 bg-black bg-opacity-50 z-50"
       onClick={() => setShowSharePopup(false)}
     ></div>
     
     {/* Share Options Popup */}
     <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl z-50 max-w-md mx-auto">
       {/* Handle bar */}
       <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mt-3 mb-4"></div>
       
       <div className="px-6 pb-6">
         <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">Share Cart</h3>
         
         {/* Share Options Grid */}
         <div className="grid grid-cols-4 gap-4 mb-6">
           {/* WhatsApp */}
           <button
             onClick={handleWhatsAppShare}
             className="flex flex-col items-center p-3 hover:bg-gray-50 rounded-lg transition-colors"
           >
             <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-2">
               <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
               </svg>
             </div>
             <span className="text-xs text-gray-600">WhatsApp</span>
           </button>
 
           {/* Telegram */}
           <button
             onClick={() => handleOtherShare('telegram')}
             className="flex flex-col items-center p-3 hover:bg-gray-50 rounded-lg transition-colors"
           >
             <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-2">
               <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                 <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
               </svg>
             </div>
             <span className="text-xs text-gray-600">Telegram</span>
           </button>
 
           {/* Facebook */}
           <button
             onClick={() => handleOtherShare('facebook')}
             className="flex flex-col items-center p-3 hover:bg-gray-50 rounded-lg transition-colors"
           >
             <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-2">
               <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                 <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
               </svg>
             </div>
             <span className="text-xs text-gray-600">Facebook</span>
           </button>
 
           {/* Copy Link */}
           <button
             onClick={() => handleOtherShare('copy')}
             className="flex flex-col items-center p-3 hover:bg-gray-50 rounded-lg transition-colors"
           >
             <div className="w-12 h-12 bg-gray-500 rounded-full flex items-center justify-center mb-2">
               <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
               </svg>
             </div>
             <span className="text-xs text-gray-600">Copy Link</span>
           </button>
         </div>
 
         {/* Cancel Button */}
         <button
           onClick={() => setShowSharePopup(false)}
           className="w-full py-3 text-gray-600 font-medium border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
         >
           Cancel
         </button>
       </div>
     </div>
   </>
 )}
 
 
 {/* Address Required Popup */}
 {showAddressRequiredPopup && (
   <>
     {/* Backdrop */}
     <div className="fixed inset-0 bg-black bg-opacity-50 z-50"></div>
     
     {/* Popup */}
     <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
       <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-lg">
         {/* Icon */}
         <div className="flex justify-center mb-4">
           <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
             <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
             </svg>
           </div>
         </div>
         
         {/* Message */}
         <p className="text-[#00000] text-center mb-6">
           Please select or choose a delivery address to place your order.
         </p>
         
         {/* Centered OK Button */}
         <div className="flex justify-center">
           <button
             onClick={() => setShowAddressRequiredPopup(false)}
             className="w-1/2 px-2 py-1 bg-[#F43042] text-white rounded-md hover:bg-red-600 transition-colors"
           >
             OK
           </button>
         </div>
       </div>
     </div>
   </>
 )}
 
 {showDeleteConfirmPopup && (
   <>
     {/* Backdrop */}
     <div className="fixed inset-0 bg-black bg-opacity-50 z-[80]"></div>
     
     {/* Popup */}
     <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-6 max-w-sm w-full mx-6 shadow-lg z-[90]">
       {/* Message */}
       <p className="text-[#000000] text-center mx-6 mb-6 text-sm">
         Are you sure you want to delete this address?
       </p>
       
       {/* Buttons */}
       <div className="flex justify-center space-x-4">
         <button
           onClick={confirmDeleteAddress} // Call the actual delete function
           className="px-6 py-2 bg-[#F43042] text-white rounded-md hover:bg-red-600 transition-colors text-sm"
         >
           Yes
         </button>
         <button
           onClick={() => setShowDeleteConfirmPopup(false)}
           className="px-6 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors text-sm"
         >
           No
         </button>
       </div>
     </div>
   </>
 )}
 
  {showAddressOptionsPopup && (
   <>
     {/* Backdrop */}
     <div 
       className="fixed inset-0 bg-black bg-opacity-70 z-[60]"
       onClick={() => setShowAddressOptionsPopup(false)}
     ></div>
     
     {/* Bottom Options Popup - Decreased height */}
     <div className="fixed bottom-0 left-0 right-0 bg-gray-100 rounded-t-2xl z-[70] max-w-md mx-auto shadow-2xl">
       {/* Handle bar */}
       <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mt-3 mb-3"></div>
       
       {/* Main container with gray background */}
       <div className="px-4 pb-4">
         <h3 className="text-md font-semibold text-[#000000] mb-3 text-left">Select Option</h3>
         
         {/* White container for options */}
         <div className="bg-white rounded-lg p-4 ">
           {/* Delete Option */}
           <button
             onClick={handleDeleteAddress}
             className="w-full flex items-center justify-between py-2 px-3 rounded-lg hover:bg-gray-50 transition-colors mb-2"
           >
             <div className="flex items-center gap-3">
               <svg className="w-4 h-4 text-[#000000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
               </svg>
               <span className="text-[#000000] font-medium text-sm">Delete Address</span>
             </div>
             <svg className="w-4 h-4 text-[#000000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
             </svg>
           </button>
 
           {/* Border line */}
           <div className="border-b border-gray-200 my-2"></div>
 
           {/* Edit Option */}
           <button
             onClick={handleEditAddress}
             className="w-full flex items-center justify-between py-2 px-3 rounded-lg hover:bg-gray-50 transition-colors"
           >
             <div className="flex items-center gap-3">
            <svg className="w-4 h-4 text-[#000000] font-regular" fill="none" stroke="currentColor" viewBox="0 0 24 24">
       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
     </svg>
               <span className="text-[#000000] font-medium text-sm">Edit Address</span>
             </div>
             <svg className="w-4 h-4 text-[#000000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
             </svg>
           </button>
         </div>
       
       </div>
     </div>
   </>
 )}
 
 
 {/* Order Placed Popup */}
 {showOrderPlacedPopup && (
   <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
     <div className="bg-white rounded-2xl p-8 mx-4 max-w-sm w-full text-center transform transition-all duration-500 scale-100 animate-bounce">
       {/* Success Icon */}
       <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 transform transition-all duration-700 scale-110">
         <svg 
           className="w-10 h-10 text-green-500" 
           fill="none" 
           stroke="currentColor" 
           viewBox="0 0 24 24"
         >
           <path 
             strokeLinecap="round" 
             strokeLinejoin="round" 
             strokeWidth={3} 
             d="M5 13l4 4L19 7"
           />
         </svg>
       </div>
       
       {/* Order Placed Text */}
       <h2 className="text-2xl font-bold text-gray-800 mb-2 transform transition-all duration-500 translate-y-0">
         RFQ Placed!
       </h2>
       
       <p className="text-gray-600 text-sm mb-4 transform transition-all duration-700 translate-y-0">
         Your RFQ has been successfully placed and is being processed.
       </p>
       
       {/* Loading Dots */}
       <div className="flex justify-center space-x-1 mb-4">
         <div className="w-2 h-2 bg-[#F43042] rounded-full animate-bounce"></div>
         <div className="w-2 h-2 bg-[#F43042] rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
         <div className="w-2 h-2 bg-[#F43042] rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
       </div>
       
       <p className="text-xs text-gray-500 animate-pulse">
         Redirecting to RFQ details...
       </p>
     </div>
   </div>
 )}
 

{showPopup && (
  <AnimatePresence>
    <motion.div
      className="fixed inset-0 bg-black/40 z-50 flex items-end justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => setShowPopup(false)} // close when clicking backdrop
    >
      <motion.div
          ref={showPopupRef}

        className="bg-white w-full max-w-md rounded-t-2xl p-6 pb-8 shadow-lg relative"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{ type: "spring", stiffness: 320, damping: 32 }}
        onClick={(e) => e.stopPropagation()} // prevent click-through
      >
        {/* Handle Indicator */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-gray-300 rounded-full" />

        {/* Title */}
        <h2 className="text-base font-semibold text-gray-900 text-left mt-4">
          Confirm Final Quote Request
        </h2>

        {/* Free Quotes Left */}
{/*         <div className="mt-2 text-[13px] text-gray-600">
          Free quotes remaining:{" "}
          <span className="font-semibold text-gray-800">2</span>
        </div> */}

        {/* Warning Box */}
        <div className="bg-[#F9FAFB] border border-gray-200 rounded-xl p-3 space-y-3 mt-4">
          <div className="flex items-start gap-2">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="w-4 h-4 text-[#F68B1E] mt-2"
            />
            <p className="text-[13px] text-gray-800 leading-snug">
              <span className="font-semibold text-gray-900">
                100 BuildCoins will be charged
              </span>{" "}
              if the final price is less than the estimated
              price and you don't place an order.
            </p>
          </div>

          <div className="flex items-start gap-2">
            <FontAwesomeIcon
              icon={faBan}
              className="w-4 h-4 text-[#F68B1E] mt-2"
            />
            <p className="text-[13px] text-gray-800 leading-snug">
              <span className="font-semibold text-gray-900">
                No quantity edits allowed
              </span>{" "}
               after the final price is received.
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-6 space-y-3">
          <button
            onClick={() => {
              handleConfirmation();
            }}
            disabled={showOrderPlacedPopup}
            className="w-full py-2.5 rounded-lg text-white font-medium bg-[#F43042] transition active:scale-[0.99]"
          >
            Confirm
          </button>

          <button
            onClick={() => setShowPopup(false)}
            className="w-full py-2 text-gray-700 font-medium bg-transparent transition"
          >
            Cancel
          </button>

          <p className="text-center text-xs text-gray-500 mt-1">
            You’ll see your best quote in about 30 minutes.
          </p>
        </div>
      </motion.div>
    </motion.div>
  </AnimatePresence>
)}

{/* Bottom Sheet Remove Item Popup */}

{ showDeleteBottomSheet && pendingRemoveItem && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-end z-50">
    <div className="bg-white w-full rounded-t-2xl p-5 animate-slide-up">

     <div className="flex justify-between items-center mb-6">
        <h2 className="text-sm font-semibold">
          Are you sure you want to remove this item?
        </h2>
      <div
          onClick={() => {
            setShowDeleteBottomSheet(false);
            setPendingRemoveItem(null);
          }}
          className="bg-gray-200 w-5 h-5 rounded-full flex items-center justify-center cursor-pointer"
        >
          <FontAwesomeIcon icon={faXmark} className="text-gray-700 text-[10px] font-bold" />
        </div>
      </div>

      {/* Item Preview Box */}
      <div className="border rounded-lg p-3 flex gap-3 items-start">
      <img
  src={
    pendingRemoveItem?.product_image
      ? imageUrl + pendingRemoveItem.product_image
      : defaultimg
  }
  alt={pendingRemoveItem?.product_name}
  className="h-14 w-14 object-contain rounded bg-gray-100"
  onError={(e) => {
    e.currentTarget.src = defaultimg;
  }}
/>

        <div className="flex-1">
          <p className="font-semibold text-sm">{pendingRemoveItem.product_name}</p>
          <p className="text-gray-700 text-sm mt-1">
            ₹{pendingRemoveItem.selling_price}
          </p>
        </div>
      </div>

      {/* ---- BUTTONS IN ONE ROW ---- */}
      <div className="flex gap-3 mt-4">
        
        {/* Delete Button */}
        <button
          className="w-1/2 bg-red-50 border border-red-500 text-red-500 text-sm font-bold flex items-center justify-center gap-2 py-2 rounded-lg"
          onClick={confirmDeleteItem}
        >
          <FontAwesomeIcon icon={faTrash} />
          REMOVE
        </button>

        {/* Save Button */}
        <button
          className="w-1/2 bg-red-500 text-white text-sm font-bold py-2 rounded-lg"
          onClick={handleSaveItem}
        >
          Saved List
        </button>

      </div>
    </div>
  </div>
)}



   <ProductSearchOverlay
        isOpen={isProductSearchOpen}
        onClose={() => setIsProductSearchOpen(false)}
        showBucket={false}
      />
 <BucketEmptyConfirmPopup
   isOpen={showEmptyBucketPopup}
   onClose={() => {
     setShowEmptyBucketPopup(false);
     setPendingRemoveItem(null);
   }}
   onConfirm={handleConfirm}
   productName={pendingRemoveItem?.name || "this item"}
 />
 
       
     </div>
   );
};

export default CartPreview;



